import { useGetFormattedEmployeeDataQuery } from "EmployerApplication/api";
import { isRenewal } from "QuotePage/urls";
import { useSelector } from "react-redux";

import { getSelectedMedicalPlans, getSelectedDentalPlan, getSelectedVisionPlan } from "Common/CartService";

export const uhcCarrierNames = ["UnitedHealthcare", "United Healthcare", "Oxford"];

export const LifePlanEligibilityMessage =
  "In order to be eligible for life insurance with UnitedHealthcare, " +
  "you must have 6+ employees, or add a UnitedHealthcare medical plan, " +
  "or add both dental and vision with UnitedHealthcare.";

export const useIsEligibleForLifePlans = ({ removingDentalPlan = false, newDentalPlan = null, removingVisionPlan = false } = {}) => {
  // If we are removing a dental or vision plan, we dont want to use the
  // currently dental plan or vision plan in cart to determine eligibility.
  const storedDentalPlan = useSelector(getSelectedDentalPlan);
  const dentalPlan = removingDentalPlan ? newDentalPlan : storedDentalPlan;

  const storedVisionPlan = useSelector(getSelectedVisionPlan);
  const visionPlan = removingVisionPlan ? null : storedVisionPlan;

  const selectedMedicalPlans = useSelector((state) => getSelectedMedicalPlans(state));

  const companyState = useSelector((state) => state.companyProfile?.state);
  const hasMedicalPlansWithUHC = [...selectedMedicalPlans].some((plan) => uhcCarrierNames.includes(plan?.carrier));

  const hasDentalPlanWithUHC = uhcCarrierNames.includes(dentalPlan?.carrier);
  const hasVisionPlanWithUHC = uhcCarrierNames.includes(visionPlan?.carrier);
  const employeeProfile = useSelector((state) => state.employeeProfile);
  const { data } = useGetFormattedEmployeeDataQuery();
  const formattedEmployeeData = data?.formatted_employee_data || [];
  const numberOfEmployees = isRenewal() ? formattedEmployeeData.length : employeeProfile.length;

  const unappointedUHCLifeStates = ["CO", "HI", "WY", "VT", "DC"];
  const meetsUHCLifeInsuranceQualifications =
    (hasMedicalPlansWithUHC || (hasDentalPlanWithUHC && hasVisionPlanWithUHC) || numberOfEmployees >= 6) && !unappointedUHCLifeStates.includes(companyState);

  return meetsUHCLifeInsuranceQualifications;
};
